export enum ProjectType {
  PROJ = "PROJ", // 일반공고
  PRCR = "PRCR", // 사전공고
  PLAN = "PLAN", // 발주계획
}

export const PROJECT_TYPE_TITLE: Record<ProjectType, string> = {
  [ProjectType.PLAN]: "발주계획",
  [ProjectType.PRCR]: "사전규격",
  [ProjectType.PROJ]: "입찰공고",
};
